import { render } from "./bid.vue?vue&type=template&id=4568084c&scoped=true"
import script from "./bid.vue?vue&type=script&lang=js"
export * from "./bid.vue?vue&type=script&lang=js"

import "./bid.vue?vue&type=style&index=0&id=4568084c&lang=scss"
import "./bid.vue?vue&type=style&index=1&id=4568084c&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4568084c"]])

export default __exports__